var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editorWrapper"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.config},on:{"ready":_vm.editorReady},model:{value:(_vm.body),callback:function ($$v) {_vm.body=$$v},expression:"body"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }